import type { InjectionKey, Ref } from "vue";

export const PIP_ATTACH_KEY: InjectionKey<Ref<HTMLElement | null>> = Symbol("pipAttach");

export const PIP_ROOT_CLASS = "pip-root";
